<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Checklist Inputs'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      @for (room of rooms; track room; let roomIndex = $index) {
          @if (room?.todos?.length > 0) {
            <tidy-row class="vertical-align-middle">
              @if (room?.category) {
                <tidy-image
                  [src]="'assets/img/icons/rooms/' + room?.icon + '.svg'"
                  class="title-size" />
              }
              <tidy-text
                [title]="room?.name" />
            </tidy-row>
          }
          @for (todoItem of room?.todos; track todoItem; let toDoIndex = $index) {
            @if (!room.complete) {
              <tidy-card [id]="todoItem.id">
                @if (todoItem?.customFieldForm) {
                  <tidy-row class="vertical-align-middle">
                    <div [ngStyle]="todoItem?.important ? {'background': '#FDF8BF', 'padding': '2px'} : {}">
                      <tidy-image
                        [src]="'assets/svg/star.svg'"
                        class="text-top-align" />
                      <tidy-text
                        [body]="todoItem?.title" />
                    </div>
                  </tidy-row>
                  <tidy-row class="extra-top-padding">
                    <form [formGroup]="rooms[roomIndex]?.todos[toDoIndex].customFieldForm">
                      @for (field of todoItem?.options; track field; let last = $last) {
                        @if (field?.name?.includes('Take Photo')) {
                          <tidy-row>
                            <tidy-text
                              [body]="field?.notes" />
                          </tidy-row>
                          @if (isNativeMobile) {
                            <tidy-button
                              [text]="'Take Photo'"
                              [action]="takeCustomToDoPhoto.bind(this, field, toDoIndex, roomIndex, todoItem, room)"
                              [class]="rooms[roomIndex].todos[toDoIndex].customFieldForm.controls[field.id].invalid && rooms[roomIndex].todos[toDoIndex].customFieldForm.controls[field.id].touched ? 'secondary take-photo-button-animation' : 'secondary'" />
                          }
                          <tidy-file-upload
                            [label]="isNativeMobile ? 'Upload Photo' : 'Add Photo'"
                            [images]="rooms[roomIndex].todos[toDoIndex].customFieldForm.controls[field.id].value || []"
                            (addedImagesChange)="uploadCustomToDoPhoto($event, field, toDoIndex, roomIndex, todoItem, room)"
                            (removedImageChange)="removeCustomToDoPhoto($event, field, toDoIndex, roomIndex, todoItem, room)" />
                        }
                        @if (field?.name === 'Text Area' || field?.name === 'Count') {
                          <tidy-row [ngClass]="!last ? 'extra-bottom-padding' : ''">
                            <tidy-textarea
                              [label]="field?.notes"
                              [icon]="'assets/svg/document-text.svg'"
                              [formControlName]="field.id"
                              [form]="rooms[roomIndex].todos[toDoIndex].customFieldForm.controls[field.id]"
                              (keyup)="updateInputedToDos(todoItem, room)"
                              [submitted]="submitted"
                              [errorMessage]="'Please enter an answer.'" />
                          </tidy-row>
                        }
                        @if (field?.name === 'Select') {
                          <tidy-row [ngClass]="!last ? 'extra-bottom-padding' : ''">
                            <tidy-radio-button
                              [label]="field?.notes"
                              [form]="rooms[roomIndex].todos[toDoIndex].customFieldForm.controls[field.id]"
                              [formControlName]="field.id"
                              [items]="field?.allowed_values"
                              (optionChange)="updateInputedToDos(todoItem, room)"
                              [submitted]="submitted"
                              [errorMessage]="'Please select an option.'" />
                          </tidy-row>
                        }
                        @if (field?.name === 'Take Inventory') {
                          <tidy-row [ngClass]="!last ? 'extra-bottom-padding' : ''">
                            <tidy-input
                              [formControlName]="field.id"
                              [form]="rooms[roomIndex].todos[toDoIndex].customFieldForm.controls[field.id]"
                              [label]="field?.notes"
                              [icon]="'assets/svg/cube.svg'"
                              inputMode="numeric"
                              [mask]="'number'"
                              (keyup)="updateInputedToDos(todoItem, room)"
                              [submitted]="submitted"
                              [errorMessage]="'Please enter an amount.'" />
                          </tidy-row>
                        }
                        @if (field?.name?.includes('Checkbox')) {
                          <tidy-row [ngClass]="!last ? 'extra-bottom-padding' : ''">
                            <tidy-row>
                              <tidy-text
                                [body]="field?.notes" />
                            </tidy-row>
                            @for (checkbox of field?.allowed_values; track checkbox) {
                              <tidy-checkbox
                                [form]="rooms[roomIndex].todos[toDoIndex].customFieldForm.controls[field.id + '-' + checkbox.viewValue]"
                                [formControlName]="field.id + '-' + checkbox.viewValue"
                                [items]="[checkbox]"
                                (checkedChange)="updateInputedToDos(todoItem, room)" />
                            }
                          </tidy-row>
                        }
                      }
                    </form>
                  </tidy-row>
                  <tidy-row class="extra-top-padding extra-bottom-padding">
                    <tidy-divider />
                  </tidy-row>
                }
                <tidy-row [ngClass]="todoItem?.customFieldForm ? 'js-todo-group' : 'js-todo-group'">
                  @if (todoItem?.customFieldForm) {
                    <tidy-radio-button
                      [(ngModel)]="todoItem.performance"
                      (optionChange)="updateInputedToDos(todoItem, room)"
                      class="horizontal-align no-wrap"
                      [items]="[{viewValue: 'Not Done', value: 'not_performed'}, {viewValue: 'Done', value: 'performed'}]" />
                  }
                  @if (!todoItem?.customFieldForm) {
                    <tidy-radio-button
                      [(ngModel)]="todoItem.performance"
                      (optionChange)="updateInputedToDos(todoItem, room)"
                      class="horizontal-align no-wrap"
                      [label]="todoItem.title"
                      [helper]="todoItem.note"
                      [icon]="todoItem.important ? 'assets/svg/star.svg' : ''"
                      [highlightLabel]="todoItem.important"
                      [items]="[{viewValue: 'Not Done', value: 'not_performed'}, {viewValue: 'Done', value: 'performed'}]" />
                  }
                </tidy-row>
              </tidy-card>
            }
          }
      }
      <tidy-button
        [text]="'Save Changes'"
        [action]="boundSaveChanges"
        class="primary" />
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
